import {
	BeneficiaryRefundModel,
	GetRefundBeneficiaries,
	type GetRefundBeneficiariesParams,
} from 'domain/usecases';

import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';

export class RemoteRefundGetBeneficiaries implements GetRefundBeneficiaries {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<BeneficiaryRefundModel>,
	) {}

	async get({signal}: GetRefundBeneficiariesParams): Promise<BeneficiaryRefundModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
